
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M272.715 381.45l-36.601-36.6 26.42-26.418 10.181 10.18 212.867-212.867L512 142.165 272.715 381.45zM0 256.921l26.417-26.418L144.38 348.464l237.771-237.769 26.418 26.419L144.38 401.305 0 256.921zm200.012-1.012l-26.418 26.42-57.096-57.098 26.418-26.418 57.096 57.096z"}})])
          )
        }
      }
    